<template>
  <div class="maladyAdd">
    <!-- 返回按钮 -->
    <el-button
      @click="goback"
      type="primary"
      size="small"
      style="margin:0 0 20px 0"
      v-if="modify"
    >
      <i class="el-icon-back"></i> 返回上一页
    </el-button>
    <!-- 表单 -->
    <el-card shadow="never">
      <h1 v-if="modify">病症修改</h1>
      <h1 v-else>病症添加</h1>
      <el-form
        label-position="top"
        label-width="80px"
        :model="form"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item
          label="病症病类"
          prop="illness_dept_cat_id"
          class="label-font"
        >
          <el-select
            v-model="form.illness_dept_cat_id"
            placeholder="请选择病症病类"
            style="width:100%;"
            @change="selectIllness"
          >
            <el-option
              v-for="item in options1"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="病症病属"
          prop="illness_belong_cat_id"
          class="label-font"
        >
          <el-select
            v-model="form.illness_belong_cat_id"
            placeholder="请选择病症病属"
            style="width:100%;"
          >
            <el-option
              v-for="item in options2"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="病症病名" prop="name" class="label-font">
          <el-input
            v-model.trim="form.name"
            placeholder="请输入病症病名"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否为常见病症" class="label-font">
          <el-select
            v-model="form.is_common"
            placeholder="是否常见病症"
            style="width:100%;"
          >
            <el-option
              v-for="item in options3"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="概述定义"
          prop="definition_desc"
          class="label-font"
        >
          <quill-editor
            class="quill-editor"
            v-model="form.definition_desc"
            :options="editorOption"
          ></quill-editor>
        </el-form-item>
        <el-form-item label="病因病机" prop="pathogeny_desc" class="label-font">
          <quill-editor
            class="quill-editor"
            v-model="form.pathogeny_desc"
            :options="editorOption"
          ></quill-editor>
        </el-form-item>
        <el-form-item
          label="分型辨证"
          prop="dialectics_desc"
          class="label-font"
        >
          <quill-editor
            class="quill-editor"
            v-model="form.dialectics_desc"
            :options="editorOption"
          ></quill-editor>
        </el-form-item>
        <el-form-item
          label="调理方案"
          prop="conditioning_scheme_desc"
          class="label-font"
        >
          <quill-editor
            class="quill-editor"
            v-model="form.conditioning_scheme_desc"
            :options="editorOption"
          ></quill-editor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit('ruleForm')">{{
            confirmText
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {
  categoryList,
  categoryDetail,
  saveIllness,
  illnessDetail,
} from "@/api/malady";
import { quillEditor } from "vue-quill-editor";
import { quillRedefine } from "vue-quill-editor-upload";
export default {
  name: "maladyAdd",
  data() {
    return {
      options1: [], // 病科列表
      options2: [], // 病症列表
      options3: [
        { value: 1, name: "常见" },
        { value: 2, name: "不常见" },
      ], // 常见列表
      form: {
        name: "",
        is_common: "",
        illness_dept_cat_id: "",
        illness_belong_cat_id: "",
        definition_desc: "",
        pathogeny_desc: "",
        dialectics_desc: "",
        conditioning_scheme_desc: "",
      },
      modify: false,
      confirmText: "确认添加",
      rules: {
        name: [
          { required: true, message: "请输入病症名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        is_common: [
          {
            required: true,
            message: "请选择是否为常见病症",
            trigger: "change",
          },
        ],
        illness_dept_cat_id: [
          { required: true, message: "请选择病科", trigger: "change" },
        ],
        illness_belong_cat_id: [
          { required: true, message: "请选择病属", trigger: "change" },
        ],
        definition_desc: [
          { required: true, message: "请填写概述定义", trigger: "blur" },
        ],
        pathogeny_desc: [
          { required: true, message: "病因病机", trigger: "blur" },
        ],
        dialectics_desc: [
          { required: true, message: "分形辨证", trigger: "blur" },
        ],
        conditioning_scheme_desc: [
          { required: true, message: "调理方案", trigger: "blur" },
        ],
      },
      editorOption: {},
    };
  },
  components: {
    quillEditor,
  },
  created() {
    const { type, id } = this.$route.query;
    if (type == "modify") {
      this.form.id = id;
      this.modify = true;
      this.confirmText = "确认修改";
    }
    this.editorOption = quillRedefine({
      // 图片上传的设置
      uploadConfig: {
        action: this.uploadAction, // 必填参数 图片上传地址
        start: () => {
          this.$message({
            message: "正在上传,请稍候...",
            duration: 0,
            showClose: true,
            type: "info",
          });
        },
        end: () => {
          this.$message.closeAll();
          this.$message.success("上传成功!");
        },
        res: (respnse) => {
          this.$message.close();
          if (respnse.code == 402) {
            this.$router.replace("login");
          }
          return respnse.data.files[0].full_path;
        },
        token: this.$store.getters.userinfo.login_token,
        size: 2048,
        name: "img", // 图片上传参数名
      },
    });
  },
  mounted() {
    this.getCategoryList();
    this.modify ? this.getData() : null;
  },
  methods: {
    // 获取病症详情
    getData() {
      illnessDetail({
        id: this.form.id,
      }).then((res) => {
        this.form = res.data;
        this.selectIllness(res.data.illness_dept_cat_id);
      });
    },
    // 获取病科
    getCategoryList() {
      categoryList().then((res) => {
        this.options1 = res.data.list;
      });
    },
    // 获取病属
    selectIllness(id) {
      categoryDetail({
        id: id,
      }).then((res) => {
        this.options2 = res.data.child_list;
      });
    },
    // 确认提交
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("是否确认提交内容?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.modify ? null : (this.form.id = 0);
            saveIllness(this.form).then(() => {
              this.$refs[formName].resetFields();
              this.$message.success("提交成功");
              this.modify ? this.goback() : null;
            });
          });
        } else {
          this.$message.error("填写内容有误!");
          return false;
        }
      });
    },
    // 返回上一页
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped></style>
